import { useAppState } from '../../AppContext';
import { scaleLinear } from 'd3-scale';
import { FaCaretDown, FaCaretRight } from 'react-icons/fa';
import { clusterColor } from '../utils';
import React from 'react';

import { keywordWidth, maxBarLength } from './constants';
import PropTypes from 'prop-types';

const GroupTitle = ({ startY, toggleCollapsed, cluster, maxClusterSize }) => {
  let [{ mousedOverCluster }, dispatch] = useAppState();

  const barScale = scaleLinear()
    .range([0, maxBarLength])
    .domain([0, maxClusterSize]);

  const thisBarLength = barScale(cluster.members.length);
  return (
    <g transform={`translate(0, ${10})`}>
      <rect
        width={thisBarLength}
        x={maxBarLength - thisBarLength}
        y={startY}
        height={keywordWidth}
        fill={'lightgrey'}
        onClick={toggleCollapsed}
      >
        <title>{cluster.members.length} documents in cluster</title>
      </rect>

      <g transform={`translate(${maxBarLength}, 0)`}>
        {/* Caret to expand/collapse cluster */}
        <g transform={`translate(0,${startY - 5})`}>
          {cluster.expanded ? (
            <FaCaretDown
              size={`30px`}
              color={clusterColor(cluster)}
              onClick={toggleCollapsed}
              title={'Click to hide documents in cluster'}
            />
          ) : (
            <FaCaretRight
              size={`30px`}
              color={clusterColor(cluster)}
              onClick={toggleCollapsed}
              title={'Click to show documents in cluster'}
            />
          )}
        </g>

        {/* count for number of docs in cluster */}
        <text
          y={startY + keywordWidth / 2 + 5}
          x={35}
          textAnchor="middle"
          fill={cluster.id === mousedOverCluster ? 'black' : 'gray'}
          fontWeight={cluster.id === mousedOverCluster ? 'bold' : 'normal'}
          onClick={toggleCollapsed}
          onMouseOver={() =>
            dispatch({
              type: 'SET_MOUSED_OVER_CLUSTER',
              mousedOverCluster: cluster.id
            })
          }
          onMouseOut={() =>
            dispatch({
              type: 'SET_MOUSED_OVER_CLUSTER',
              mousedOverCluster: null
            })
          }
        >
          {cluster.members.length}
        </text>

        {/* Keyword labels */}
        <text
          x={keywordWidth + 40}
          y={startY + keywordWidth / 2 + 5}
          fontWeight={'bold'}
          id={`cluster-${cluster.id}`}
          fill="black"
          onClick={toggleCollapsed}
          onMouseOver={() =>
            dispatch({
              type: 'SET_MOUSED_OVER_CLUSTER',
              mousedOverCluster: cluster.id
            })
          }
          onMouseOut={() =>
            dispatch({
              type: 'SET_MOUSED_OVER_CLUSTER',
              mousedOverCluster: null
            })
          }
        >
          {cluster.is_outlier ? 'Unclustered documents' : cluster.labels}
        </text>
      </g>
    </g>
  );
};

GroupTitle.propTypes = {
  startY: PropTypes.number,
  cluster: PropTypes.shape({
    members: PropTypes.array.isRequired,
    expanded: PropTypes.bool.isRequired,
    keywords: PropTypes.arrayOf(PropTypes.string),
    labels: PropTypes.string,
    id: PropTypes.number,
    is_outlier: PropTypes.bool
  }),
  toggleCollapsed: PropTypes.func,
  maxClusterSize: PropTypes.number
};

export default GroupTitle;
